import {
  BrowserRouter as Router,
  Route,
  Routes,
  useLocation,
  BrowserRouter,
} from "react-router-dom";
import { useEffect, useState, lazy, Suspense } from "react";
// import AOS from "aos";
// import "aos/dist/aos.css";
import "./App.css";
import MainFooter from "./component/Layout/Footer";
import Navbar from "./component/Layout/Header";
import PEObjectRemoval from "./component/Pages/PEObjectRemoval";
import useApiRequest, { ScrollToTop } from "./utils/helperFunctions";
import { LoadingOutlined } from "@ant-design/icons";
import VirtualStagingForm from "./component/Form/VirtualStagingForm";
import VirtualRenovationForm from "./component/Form/VirtualRenovationForm";
import FloorPlanForm from "./component/Form/FloorPlanForm";
import DaytoDuskForm from "./component/Form/DaytoDuskForm";
import ObjectRemovalForm from "./component/Form/ObjectRemoval";
import ImageEnhacementForm from "./component/Form/ImageEnhanceForm";
import OccupiedVacantForm from "./component/Form/OccupiedForm";
import BuisnessCardForm from "./component/Form/BuisnessCardForm";
import PosterDesignForm from "./component/Form/PosterDesignForm";
import VectorDesignForm from "./component/Form/VectorDesignForm";
import DigitalDisplayForm from "./component/Form/DigitalDisplayForm";
import ResidentialPage from "./component/Pages/Residential";
import CommercialPage from "./component/Pages/Commercial";
import GraphicDesignPage from "./component/Pages/GraphicDesigning";
import PhotoEditingPage from "./component/Pages/PhotoEditingPage";
import TopHomeButton from "./utils/TopHomeButton";
import CommImageEnhacement from "./component/Pages/CommImageEnhacement";
import ThankYouPage from "./component/Pages/MakePayment/Thanks";
import TestPage from "./component/Pages/TestPage";
import OrderEditForm from "./component/Form/OrderVSEditForm";
import Clarity from "@microsoft/clarity";

// Lazy loading for pages
const UserDOrders = lazy(() => import("./component/UserDashboard/UserDOrders"));
const UserDHome = lazy(() => import("./component/UserDashboard/UserDHome"));
const UserDServices = lazy(
  () => import("./component/UserDashboard/UserDServices")
);
const UserDSupport = lazy(
  () => import("./component/UserDashboard/UserDSupport")
);
const Home = lazy(() => import("./component/Pages/Home/Home"));
const TryForFree = lazy(() => import("./component/Pages/TryForFree"));
const VirtualStaging = lazy(() => import("./component/Pages/VirtualStaging"));
const VirtualRenovation = lazy(
  () => import("./component/Pages/VirtualRenovation")
);
const FloorPlan = lazy(() => import("./component/Pages/FloorPlan"));
const DaytoDusk = lazy(() => import("./component/Pages/DaytoDusk"));
const ObjectRemoval = lazy(() => import("./component/Pages/ObjectRemoval"));
const Brightening = lazy(() => import("./component/Pages/Brightening"));
const CommercialStaging = lazy(
  () => import("./component/Pages/CommercialStaging")
);
const CommercialRenovation = lazy(
  () => import("./component/Pages/CommercialRenovation")
);
const PhotoEditing = lazy(() => import("./component/Pages/PhotoEditing"));
const LogoBranding = lazy(() => import("./component/Pages/LogoBranding"));
const VectorDesign = lazy(() => import("./component/Pages/VectorDesign"));
const DigitalDisplay = lazy(() => import("./component/Pages/DigitalDesign"));
const OccupiedVacant = lazy(() => import("./component/Pages/Occupied2Vacant"));
const OrderForm = lazy(() => import("./component/Form/OrderForm"));
const CommercialStagingForm = lazy(
  () => import("./component/Form/CommercialStagingForm")
);
const UserDashboard = lazy(
  () => import("./component/UserDashboard/DashboardSidebar")
);
const LoginSignup = lazy(
  () => import("./component/Pages/LoginSignup/LoginSignupComponent")
);
const Cart = lazy(() => import("./component/Pages/Cart"));
const NotFound = lazy(() => import("./component/Pages/Error404"));
const Testimonials = lazy(() => import("./component/Pages/Reviews"));
const BlogPage = lazy(() => import("./component/Pages/Blog"));
const Gallery = lazy(() => import("./component/Pages/Gallery"));
const PrintAds = lazy(() => import("./component/Pages/PrintAdvertizement"));
const ContactUs = lazy(() => import("./component/Pages/ContactUs"));
const TermsCon = lazy(() => import("./component/Pages/TermsCon"));
const PrivacyPolicy = lazy(() => import("./component/Pages/Privacy"));
const AboutUs = lazy(() => import("./component/Pages/AboutUS"));
const BulkQuotes = lazy(() => import("./component/Form/BulkQuotes"));
const Profile = lazy(() => import("./component/Pages/Profile"));
const PhotoEditingForm = lazy(
  () => import("./component/Form/PhotoEditingForm")
);
const Paypal = lazy(() => import("./component/Pages/MakePayment"));
const CommDaytoDusk = lazy(
  () => import("./component/Pages/CommercialDaytoDusk")
);
const CommObjectRemoval = lazy(
  () => import("./component/Pages/CommObjRemoval")
);
const CommOccupiedVacant = lazy(
  () => import("./component/Pages/CommOccVacant")
);
const PEOccupiedVacant = lazy(() => import("./component/Pages/PEOccVacant"));
const PEImageEnhacement = lazy(
  () => import("./component/Pages/ImageEnhancement")
);
const PEDaytoDusk = lazy(() => import("./component/Pages/PEDayToDusk"));
const RefundPage = lazy(() => import("./component/Pages/Refund/refund"));

function App() {
  // const showHeaderFooterPaths = ["/user-dashboard", "/"]; // Paths where the header and footer should be shown.
  const [userDash, setUserDash] = useState(false);
  const [navigator, setNavi] = useState(false);

  const location = useLocation();
  // useEffect(() => {
  //   window.scrollTo(0, 0);
  // }, [location.pathname]); // 👈 This makes scroll work on route change

  // const showHeader = () => {
  //   const showHeaderFooterPaths = ["/user-dashboard", "/", "/thank-you", "/account"];
  //   return showHeaderFooterPaths.includes(location.pathname);
  // };

  // const showFooter = () => {
  //   const showFooterPaths = ["/user-dashboard", "/account", "/about-us", "/thank-you"];
  //   return !showFooterPaths.includes(location.pathname);
  // };
  // useEffect(() => {
  //   window.scrollTo(0, 0);
  // }, [window.location.href]);

  const showHeader = () => {
    let easyCheck = false;
    let hardCheck = false;
    let showHeaderFooterPaths = [
      "/user-dashboard",
      "/",
      "/thank-you",
      "/account",
      "/edit",
      "/terms-and-conditions",
      "/privacy-policy",
      "/refund-policy",
      "/dashboard",
    ]; // Paths where the header and footer should be shown.

    // Check if the current path exactly matches any of these paths.
    showHeaderFooterPaths.find((value) => {
      if (window.location.pathname.includes(value)) {
        hardCheck = window.location.pathname.includes(value);
      }
      return window.location.pathname.includes(value);
    });
    easyCheck = showHeaderFooterPaths.includes(window.location.pathname);
    // console.log(easyCheck||hardCheck)
    // return showHeaderFooterPaths.includes(window.location.pathname);
    return easyCheck || hardCheck;
  };

  const showFooter = () => {
    let hideFooterPaths = [
      "/user-dashboard",
      "/account",
      "/about-us",
      "/thank-you",
      "/terms-and-conditions",
      "/refund-policy",
      "/privacy-policy",
    ];

    if (window.innerWidth <= 425) {
      hideFooterPaths.push("/dashboard");
    }

    return !hideFooterPaths.includes(location.pathname);
  };

  useEffect(() => {
    setNavi(showHeader());
    showFooter();
  }, [window.location.href]);

  const projectId: string = process.env.REACT_APP_CLARITY_PROJECT_ID || "";

  Clarity.init(projectId);

  useEffect(() => {
    const isLoggedIn = localStorage.getItem("LoggedIn") === "true";
    const isAuthPage = location.pathname === "/login";

    if (!isLoggedIn && !isAuthPage) {
      const fullPath = location.pathname + location.search;
      localStorage.setItem("lastPath", fullPath);
    }
  }, [location.pathname, location.search]);

  return (
    <>
      <ScrollToTop />
      <div style={{ display: userDash ? "none" : "none" }}></div>
      <div className="App">
        <Suspense
          fallback={
            <div
              style={{
                height: "98vh",
                display: "Flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <LoadingOutlined
                style={{
                  fontSize: "55px",
                  color: "#32ae96",
                }}
              />
            </div>
          }
        >
          {/* {userDash?showHeader() ? <Navbar static={false} /> : <Navbar static={true} />:null} */}
          {/* {navigator ? <Navbar static={false} /> : <Navbar static={true} />} */}
          <Navbar static={navigator} />
          <Routes>
            {/* General Pages */}
            <Route
              path="/"
              index
              element={<Home setUserDash={setUserDash} />}
              errorElement={<NotFound />}
            />

            <Route
              path="/account"
              element={<LoginSignup setUserDash={setUserDash} />}
            />
            <Route path="/payment" element={<Paypal />} />
            <Route path="/contact-us" element={<ContactUs />} />
            <Route path="/about-us" element={<AboutUs />} />
            <Route path="/try-for-free" element={<TryForFree />} />

            {/* Services Pages */}
            <Route
              path="/virtual-staging"
              element={<VirtualStaging />}
            />

            <Route path="/services/residential" element={<ResidentialPage />} />

            <Route path="/services/commercial" element={<CommercialPage />} />

            <Route
              path="/services/graphic-designing"
              element={<GraphicDesignPage />}
            />

            <Route
              path="/virtual-renovation"
              element={<VirtualRenovation />}
            />
            <Route
              path="/services/residential/floor-plan"
              element={<FloorPlan />}
            />

            <Route
              path="/services/residential/day-to-dusk"
              element={<DaytoDusk />}
            />

            <Route
              path="/services/commercial/day-to-dusk"
              element={<CommDaytoDusk />}
            />

            <Route
              path="/services/residential/object-removal"
              element={<ObjectRemoval />}
            />

            <Route
              path="/services/commercial/object-removal"
              element={<CommObjectRemoval />}
            />

            <Route
              path="/services/commercial/virtual-staging"
              element={<CommercialStaging />}
            />
            <Route
              path="/services/commercial/commercial-renovation"
              element={<CommercialRenovation />}
            />

            <Route
              path="/services/commercial/occupied-to-vacant"
              element={<CommOccupiedVacant />}
            />
            <Route
              path="/services/residential/occupied-to-vacant"
              element={<OccupiedVacant />}
            />

            <Route
              path="/services/commercial/image-enhancement"
              element={<CommImageEnhacement />}
            />
            <Route
              path="/services/residential/residential-image-enhancement"
              element={<Brightening />}
            />

            {/* Graphic Design Pages */}

            {/* <Route
                path="/services/graphic-designing/business-card-design"
                element={<LogoBranding />}
              />
              <Route
                path="/services/graphic-designing/vector-design"
                element={<VectorDesign />}
              />
              <Route
                path="/services/graphic-designing/digital-display-design"
                element={<DigitalDisplay />}
              />
              <Route
                path="/services/graphic-designing/logo-branding"
                element={<PrintAds />}
            /> */}

            {/* Graphic Design Pages Ends */}

            {/* Photo Editing Pages */}
            <Route
              path="/services/photo-editing"
              element={<PhotoEditingPage />}
            />

            <Route
              path="/occupied-to-vacant"
              element={<PEOccupiedVacant />}
            />

            <Route
              path="/image-enhancement"
              element={<PEImageEnhacement />}
            />
            <Route path="/day-to-dusk" element={<PEDaytoDusk />} />
            <Route
              path="/object-removal"
              element={<PEObjectRemoval />}
            />
            {/* Photo Editing Pages Ends */}

            {/* Forms Pages */}
            <Route path="/services/edit-order" element={<OrderEditForm />} />
            <Route
              path="/services/commercial/virtual-staging-form"
              element={<CommercialStagingForm />}
            />

            <Route
              path="/edit/services/commercial/virtual-staging-form"
              element={<CommercialStagingForm />}
            />

            <Route
              path="/services/commercial/commercial-staging-form"
              element={<CommercialStagingForm />}
            />

            <Route
              path="/edit/services/commercial/commercial-staging-form"
              element={<CommercialStagingForm />}
            />

            <Route
              path="/services/commercial/virtual-renovation-form"
              element={<CommercialStagingForm />}
            />

            <Route
              path="/edit/services/commercial/virtual-renovation-form"
              element={<CommercialStagingForm />}
            />

            <Route
              path="/services/commercial/commercial-renovation-form"
              element={<CommercialStagingForm />}
            />

            <Route
              path="/edit/services/commercial/commercial-renovation-form"
              element={<CommercialStagingForm />}
            />

            <Route path="/thank-you" element={<ThankYouPage />} />

            <Route
              path="/services/virtual-staging-form"
              element={<VirtualStagingForm />}
            />

            <Route
              path="/edit/services/virtual-staging-form"
              element={<VirtualStagingForm />}
            />

            <Route
              path="/services/virtual-renovation-form"
              element={<VirtualRenovationForm />}
            />

            <Route
              path="/edit/services/virtual-renovation-form"
              element={<VirtualRenovationForm />}
            />

            <Route
              path="/services/floor-plan-form"
              element={<FloorPlanForm />}
            />

            <Route
              path="/edit/services/floor-plan-form"
              element={<FloorPlanForm />}
            />

            <Route
              path="/services/day-to-dusk-form"
              element={<DaytoDuskForm />}
            />

            <Route
              path="edit/services/day-to-dusk-form"
              element={<DaytoDuskForm />}
            />

            <Route
              path="/services/object-removal-form"
              element={<ObjectRemovalForm />}
            />

            <Route
              path="/edit/services/object-removal-form"
              element={<ObjectRemovalForm />}
            />

            <Route
              path="/services/image-enhancement-form"
              element={<ImageEnhacementForm />}
            />

            <Route
              path="/edit/services/image-enhancement-form"
              element={<ImageEnhacementForm />}
            />

            <Route
              path="/services/occupied-vacant-form"
              element={<OccupiedVacantForm />}
            />

            <Route
              path="/edit/services/occupied-vacant-form"
              element={<OccupiedVacantForm />}
            />

            <Route
              path="/services/business-card-form"
              element={<BuisnessCardForm />}
            />

            <Route
              path="/edit/services/business-card-form"
              element={<BuisnessCardForm />}
            />

            <Route
              path="/services/poster-design-form"
              element={<PosterDesignForm />}
            />

            <Route
              path="/edit/services/poster-design-form"
              element={<PosterDesignForm />}
            />

            <Route
              path="/services/vector-design-form"
              element={<VectorDesignForm />}
            />

            <Route
              path="/edit/services/vector-design-form"
              element={<VectorDesignForm />}
            />

            <Route
              path="/services/digital-display-form"
              element={<DigitalDisplayForm />}
            />

            <Route
              path="/edit/services/digital-display-form"
              element={<DigitalDisplayForm />}
            />

            <Route path="/order-bulk-quotes" element={<BulkQuotes />} />
            <Route path="/photo-editing-form" element={<PhotoEditingForm />} />
            <Route
              path="/edit/photo-editing-form"
              element={<PhotoEditingForm />}
            />

            {/* Other Pages */}
            <Route path="/cart" element={<Cart />} />
            <Route path="/reviews" element={<Testimonials />} />
            <Route path="/blogs" element={<BlogPage />} />
            <Route path="/gallery" element={<Gallery />} />

            {/* User Dashboard */}
            <Route
              path="/dashboard"
              element={<UserDashboard checking={setUserDash} />}
            >
              <Route index element={<UserDHome />} />
              <Route path="my_services" element={<UserDServices />} />
              <Route path="my_support" element={<UserDSupport />} />
              <Route path="my_orders" element={<UserDOrders />} />
            </Route>
            {/* TestPage */}
            {/* <Route path="/test" element={<TestParent />} >
              <Route index element={<TestChildOne/>}/>
              <Route path={"/test/page-two"} element={<TestChildTwo/>}/>
            </Route> */}

            {/* 404 Route */}
            <Route path="*" element={<NotFound />} />

            {/* Terms and Conditions */}
            <Route path="/terms-and-conditions" element={<TermsCon />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/refund-policy" element={<RefundPage />} />
          </Routes>
          <TopHomeButton />
          {showFooter() && <MainFooter />}
        </Suspense>
      </div>
    </>
  );
}

export default App;
